
import * as z from 'zod';

export const flightUpdateSchema = z.object({
  flight_id: z.string().min(1, "Please select a flight"),
  status: z.enum([
    "Scheduled",
    "Check-in Open",
    "Check-in Closed",
    "Boarding Soon",
    "Boarding",
    "Gate Closed",
    "On Time",
    "Delayed",
    "Departed",
    "In Air",
    "Diverted",
    "Recovery",
    "Landed",
    "Arrived",
    "Cancelled"
  ]),
  scheduled_departure: z.string().optional(),
  scheduled_arrival: z.string().optional(),
  status_reason: z.string().optional(),
});

export type FlightUpdateFormValues = z.infer<typeof flightUpdateSchema>;
